import { useTranslation } from '@thoughtspot/i18n';
import { getPrincipalObjectExportLimit } from '@thoughtspot/session-service';
import { useEffect, useState } from 'react';
import { ValidEdocMetadataType } from "../../../../../services/generated/graphql-types";
import { useGetEdocLazyQuery } from "../../../../../services/user-group/user-group-service";
import { ExportTMLOptions } from '../../../../user-management/users/ExportUserTMLoptions';
import { downloadExportedUsers } from '../../../../user-management/users/util';
import { V2TranslationKeys } from '../constants';
export const useExportUsers = ({ isClusterAdmin, isTmlObjectIdFlagEnabled, onError, onClose, clearSelection, setIsLoading, }) => {
    const { t } = useTranslation();
    const [shouldExportDependencies, setShouldExportDependencies] = useState(true);
    const { getEdoc: getEdocLazyQuery, data: edocData, loading: isGetEdocLoading, error: isEdocError, } = useGetEdocLazyQuery();
    useEffect(() => {
        if (isEdocError && !isGetEdocLoading) {
            onError(t(V2TranslationKeys.EXPORT_LIMIT_ERROR, {
                limit: getPrincipalObjectExportLimit(),
            }));
            setIsLoading(false);
            onClose();
        }
        else if (edocData && !isGetEdocLoading) {
            downloadExportedUsers(edocData, shouldExportDependencies);
            setIsLoading(false);
            onClose();
            clearSelection();
        }
    }, [edocData, isGetEdocLoading, isEdocError]);
    const exportUsers = (userIds) => {
        setIsLoading(true);
        const payload = userIds.map(id => ({
            id,
            type: ValidEdocMetadataType.User,
        }));
        getEdocLazyQuery(payload, shouldExportDependencies, false, isClusterAdmin, isTmlObjectIdFlagEnabled, isTmlObjectIdFlagEnabled);
    };
    const onExportRadioChange = (event) => {
        setShouldExportDependencies(event.target.value === ExportTMLOptions.OBJECT_WITH_DEPENDENCIES);
    };
    return {
        shouldExportDependencies,
        isGetEdocLoading,
        exportUsers,
        onExportRadioChange,
    };
};
//# sourceMappingURL=useExportUsers.js.map